module.exports = __webpack_public_path__ + "images/16292-INT1-Cam02-6546b0d9dc8c0d409e98b32f4adc4d52.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/Carousel_1/16292-INT1-Cam02.jpg
// module id = 30
// module chunks = 0